import { render, staticRenderFns } from "./rukuKuizhang.vue?vue&type=template&id=4c962a68&scoped=true&"
import script from "./rukuKuizhang.vue?vue&type=script&lang=js&"
export * from "./rukuKuizhang.vue?vue&type=script&lang=js&"
import style0 from "./rukuKuizhang.vue?vue&type=style&index=0&id=4c962a68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c962a68",
  null
  
)

export default component.exports